var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import css from './Container.module.scss';
export var Container = function (_a) {
    // Add all classs to an array
    var children = _a.children, id = _a.id, className = _a.className;
    return (_jsx("article", __assign({ id: id, className: "".concat(className, " ").concat(css.container) }, { children: children })));
};
